import React from 'react';
import * as Ramda from 'ramda';

import useNotifications from '../../_lib/notifications/useNotifications';
import type { AxiosError } from 'axios';
import { manageAPIError } from '../../utils';

type APIErrorHandler = (
  fallbackMsg: string
) => (error: Error | AxiosError) => void;

export function useAPIErrorHandler() {
  const notifications = useNotifications();

  return React.useMemo<APIErrorHandler>(() => {
    return Ramda.curryN(2)(
      Ramda.compose(
        (message: string) => notifications.error(message),
        Ramda.flip(manageAPIError)
      )
    );
  }, [notifications]);
}
